import Archive from "./Archive";
import ArchiveProjects from "./ArchiveProjects";
import Header from "./Header";
import Hero from "./Hero";
import News from "./News";
import NewsLetter from "./NewsLetter";
import OpenCallsSignup from "./OpenCallsSignup";
import BlockAboutNewsLetter from "./BlockAboutNewsLetter";

const app = {
  init: () => {
    console.log("Net Zero Industry");

    Header.init();
    Hero.init();
    News.init();

    NewsLetter.init();
    OpenCallsSignup.init();
    BlockAboutNewsLetter.init();

    Archive.init();
    ArchiveProjects.init();
  },
};

// document ready
document.readyState === "loading"
  ? document.addEventListener("DOMContentLoaded", app.init)
  : app.init();
